import { render, staticRenderFns } from "./LeaveEntitlement.vue?vue&type=template&id=07a89762"
import script from "./LeaveEntitlement.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports